import React, { useEffect } from 'react'
import {
  Switch,
  Route,
  Redirect
} from 'react-router-dom'
import { RedocStandalone } from 'redoc'

import octopus131 from '../specs/octopus-1.3.1.yml'
import octopus140 from '../specs/octopus-1.4.0.yml'
import octopus150 from '../specs/octopus-1.5.0.yml'
import octopus200 from '../specs/octopus-2.0.0.yml'
import octopus203 from '../specs/octopus-2.0.3.yml'
import octopus235 from '../specs/octopus-2.3.5.yaml'
import octopus2230 from '../specs/octopus-2.4.0.yaml'

import defaultTheme from '../themes/defaultTheme'

const OtterioPage = () => {
  useEffect(() => {
    document.title = 'Octopus | DigiPay Developer'
  }, [])
  return (
    <Switch>
      <Route exact path='/documents/octopus/2.4.0'>
        <RedocStandalone
          spec={octopus2230}
          options={{ theme: defaultTheme }}
        />
      </Route>
      <Route exact path='/documents/octopus/2.3.5'>
        <RedocStandalone
          spec={octopus235}
          options={{ theme: defaultTheme }}
        />
      </Route>
      <Route exact path='/documents/octopus/2.0.3'>
        <RedocStandalone
          spec={octopus203}
          options={{ theme: defaultTheme }}
        />
      </Route>
      <Route exact path='/documents/octopus/2.0.0'>
        <RedocStandalone
          spec={octopus200}
          options={{ theme: defaultTheme }}
        />
      </Route>
      <Route exact path='/documents/octopus/1.5.0'>
        <RedocStandalone
          spec={octopus150}
          options={{ theme: defaultTheme }}
        />
      </Route>
      <Route exact path='/documents/octopus/1.4.0'>
        <RedocStandalone
          spec={octopus140}
          options={{ theme: defaultTheme }}
        />
      </Route>
      <Route exact path='/documents/octopus/1.3.1'>
        <RedocStandalone
          spec={octopus131}
          options={{ theme: defaultTheme }}
        />
      </Route>
      <Route>
        <Redirect to='/documents/octopus/2.4.0' />
      </Route>
    </Switch>
  )
}

export default OtterioPage
